export class FailedToFetchError extends Error {
    constructor(params) {
        const { url, queryParams, headers, response, } = params;
        super(`Failed to fetch data from url: ${url}`);
        this._url = url;
        this._queryParams = queryParams;
        this._headers = headers;
        this._response = response;
    }
    get details() {
        return {
            url: this._url,
            queryParams: this._queryParams,
            headers: this._headers,
            response: this._response,
        };
    }
}
//# sourceMappingURL=FailedToFetchError.js.map